// constants
const initialState = {
  brand: '',
  brandID: '',
  model: '',
  modelID: '',
  year: '',
  versionID: '',
  version: '',
  zerokm: '',
  // gnc: '',
  zipcode: ''
};

export const SELECT_BRAND = 'SELECT_BRAND';
export const SELECT_MODEL = 'SELECT_MODEL';
export const SELECT_YEAR = 'SELECT_YEAR';
export const SELECT_VERSION = 'SELECT_VERSION';
// export const SELECT_GNC = 'SELECT_GNC';
export const SELECT_ZIPCODE = 'SELECT_ZIPCODE';

// actions
export const selectBrand = (brandID, brand) => {
  return {
    type: SELECT_BRAND,
    payload: {
      brandID,
      brand
    }
  };
};

export const selectModel = (model) => {
  return {
    type: SELECT_MODEL,
    payload: {
      model
    }
  };
};

export const selectYear = (year, zerokm) => {
  return {
    type: SELECT_YEAR,
    payload: {
      year,
      zerokm
    }
  };
};

export const selectVersion = (version, modelID, versionID) => {
  return {
    type: SELECT_VERSION,
    payload: {
      version,
      modelID,
      versionID
    }
  };
};

// export const selectGnc = (gnc) => {
//   return {
//     type: SELECT_GNC,
//     payload: gnc
//   };
// };

export const selectZipcode = (zipcode) => {
  return {
    type: SELECT_ZIPCODE,
    payload: zipcode
  };
};

// reducer
export default function reducer(state = initialState, action) {
  switch (action.type) {
    case SELECT_BRAND:
      return {
        ...state,
        brandID: action.payload.brandID,
        brand: action.payload.brand
      };
    case SELECT_MODEL:
      return {
        ...state,
        model: action.payload.model
      };
    case SELECT_YEAR:
      return {
        ...state,
        year: action.payload.year,
        zerokm: action.payload.zerokm
      };
    case SELECT_VERSION:
      return {
        ...state,
        modelID: action.payload.modelID,
        versionID: action.payload.versionID,
        version: action.payload.version
      };
    // case SELECT_GNC:
    //   return {
    //     ...state,
    //     gnc: action.payload
    //   };
    case SELECT_ZIPCODE:
      return {
        ...state,
        zipcode: action.payload
      };
    default:
      return state;
  }
}
